import React, {useEffect} from 'react'
import {URLS} from '../../constants/urls'
import {isServer} from 'ac-share'
import {useLoadLegal} from './hooks/useLoadLegal'
import {HtmlView, Loading} from 'ac_ui'

const BASE_URL = 'https://learndb.ru'

const OfferPhysical: React.FC = () => {
  let offer = useLoadLegal('offer')
  useEffect(() => {
    if (!isServer) {
      window.scrollTo(0, 0)
    }
  }, [])

  if (offer) {
    offer = offer.replace(/\{URLS.legal \+ URLS.offer\}/gi, BASE_URL + URLS.legal + URLS.offer)
    offer = offer.replace(/\{URLS.legal \+ URLS.privacy\}/gi, BASE_URL + URLS.legal + URLS.privacy)
    offer = offer.replace(/\{URLS.legal \+ URLS.license\}/gi, BASE_URL + URLS.legal + URLS.license)
    offer = offer.replace(/\{URLS.themes\}/gi, BASE_URL + URLS.themes)
    offer = offer.replace(/\{URLS.payment\}/gi, BASE_URL + URLS.payment)
  }

  return (
    <div className={'legal-content'}>
      {offer ? (
        <HtmlView html={offer} />
      ) : (
        <div className={'d-flex flex-column align-items-center w-100 pt-x4'}>
          <Loading />
        </div>
      )}
    </div>
  )
}

export {OfferPhysical}
